import {
  ArnDelegateNftService,
  ArnInternalNftService,
} from '../ArnDelegateNftService';
import {
  ArnNftListOptions,
  NmpCertificatesResponse,
  UrlUtil,
} from '@arianee/arn-types';
import { ArnArianeeNftService } from './ArnArianeeNftService';

export class DefaultArianeeNftService
  extends ArnDelegateNftService
  implements ArnArianeeNftService
{
  constructor(nft: ArnInternalNftService) {
    super(nft);
  }

  async getList(
    options?: ArnNftListOptions
  ): Promise<NmpCertificatesResponse[]> {
    const results = await this.http.sendAuthorizedJson<
      NmpCertificatesResponse[]
    >(this.auth, UrlUtil.join(this.config.list.url, '/'), options || {});
    this.context?.cache.set(JSON.stringify(options), results);
    return results;
  }
}
